/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Insert_Music_NoteInputs */

const en_shortcut_keys_desc_insert_music_note = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Music_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert single music note`)
};

const fr_shortcut_keys_desc_insert_music_note = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Music_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserer une note de musique`)
};

const de_shortcut_keys_desc_insert_music_note = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Music_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge eine einzelne Musiknote ein.`)
};

const it_shortcut_keys_desc_insert_music_note = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Music_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci una singola nota musicale`)
};

const ru_shortcut_keys_desc_insert_music_note = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Music_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставьте отдельную музыкальную ноту`)
};

const es_shortcut_keys_desc_insert_music_note = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Music_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar una sola nota musical`)
};

const zh_cn2_shortcut_keys_desc_insert_music_note = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Music_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插入一个音符`)
};

const ja_shortcut_keys_desc_insert_music_note = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Music_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単一の音符を挿入する`)
};

const hi_shortcut_keys_desc_insert_music_note = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Music_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एकल संगीत नोट डालें`)
};

const pt_pt2_shortcut_keys_desc_insert_music_note = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Music_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserir uma única nota musical`)
};

/**
* | output |
* | --- |
* | "Insert single music note" |
*
* @param {Shortcut_Keys_Desc_Insert_Music_NoteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_insert_music_note = /** @type {((inputs?: Shortcut_Keys_Desc_Insert_Music_NoteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Insert_Music_NoteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_insert_music_note(inputs)
	if (locale === "de") return de_shortcut_keys_desc_insert_music_note(inputs)
	if (locale === "it") return it_shortcut_keys_desc_insert_music_note(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_insert_music_note(inputs)
	if (locale === "es") return es_shortcut_keys_desc_insert_music_note(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_insert_music_note(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_insert_music_note(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_insert_music_note(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_insert_music_note(inputs)
	return en_shortcut_keys_desc_insert_music_note(inputs)
});